import styled from 'styled-components'

import { style } from 'theme'

const Caption = styled.p`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  margin: 0;
`

export default Caption
